export const PROFESSIONS_PHRASES = {
    ADMINISTRATOR: 15448,
    BIOMEDICAL_ENGINEER: 15483,
    DENTAL_PROFESSIONAL: 15443,
    EYE_CARE_PROFESSIONAL: 15454,
    LABORATORY_CLINICAL_RESEARCHER: 15450,
    MEDICAL_STUDENT: 15456,
    MEDICAL_TECHNOLOGIST: 15485,
    MIDWIFE: 15484,
    NONCLINICAL_HEALTHCARE_PROFESSIONAL: 15487,
    NURSING_PROFESSIONAL: 15444,
    OTHER_CLINICAL_HEALTHCARE_PROFESSIONAL: 15486,
    PATIENT_CONSUMER: 15464,
    PHARMACY_PROFESSIONAL: 15446,
    PHYSICIAN_ASSISTANT: 15442,
    PHYSICIAN_POST_TRAINING: 15441,
    PHYSICIAN_IN_TRAINING_RESIDENT_FELLOW: 19723,
    PUBLIC_HEALTH: 15462,
    VETERINARIAN: 15482,
    AYUSH_DOCTOR_PRACTIONER: 21459,
} as const;

export const SPECIALTY_PHRASES = {
    AESTHETIC_MEDICINE: 15655,
    ALLERGY_IMMUNOLOGY: 15611,
    ANESTHESIOLOGY: 15612,
    AUDIOLOGY: 15656,
    CARDIOLOGY: 15617,
    COMPLEMENTARY_MEDICINE: 15637,
    CRITICAL_INTENSIVE_CARE: 15667,
    DERMATOLOGY: 15613,
    DIET_NUTRITION: 15657,
    EMERGENCY_MEDICINE: 15614,
    ENDOCRINOLOGY_DIABETES: 15618,
    FAMILY_MEDICINE_GENERAL_PRACTICE: 15615,
    GASTROENTEROLOGY: 15619,
    GERIATRIC_MEDICINE: 15671,
    HEMATOLOGY: 15668,
    HEMATOLOGY_ONCOLOGY: 15670,
    HEPATOLOGY: 15653,
    HOSPITALIST: 15646,
    INFECTIOUS_DISEASE: 15621,
    INTERNAL_MEDICINE: 15666,
    LEGAL_FORENSIC_MEDICINE: 15651,
    MEDICAL_GENETICS: 15638,
    NEPHROLOGY: 15622,
    NEUROLOGY: 15623,
    OBSTETRICS_GYNECOLOGY: 15626,
    ONCOLOGY: 15669,
    OPTHALMOLOGY: 15627,
    ORTHOPEDICS: 15628,
    OTORHINOLARYNGOLOGY_ENT: 15629,
    PAIN_MANAGEMENT: 15644,
    PATHOLOGY: 15630,
    PEDIATRICS: 15631,
    PHLEBOLOGY: 15650,
    PHYSICAL_MEDICINE_REHABILITATION: 15647,
    PHYSICAL_OCCUPAT_THERAPY: 15640,
    PODIATRY: 15639,
    PSYCHIATRY: 15632,
    PULMONOLOGY: 15624,
    RADIOLOGY: 15633,
    RHEUMATOLOGY: 15625,
    SURGERY: 15634,
    UROLOGY: 15635,
    VASCULAR_MEDICINE: 15654,
} as const;

export const COUNTRIES_PHRASES = {
    AFGHANISTAN: 14983,
    ALBANIA: 14987,
    CANADA: 15022,
    CHINA: 15026,
    UNITED_KINGDOM: 15062,
    USA: 15217,
} as const;

export const HOW_HEARD_PHRASES = {
    OTHER_SOCIAL_MEDIA: 13234,
    OTHER: 13237,
} as const;
